import { getInstrumentationContext } from 'owa-mail-list-store/lib/selectors/mailRowDataPropertyGetter';
/**
 *
 * @param rowKeys string[] holding rowKeys from tableView
 * @param tableView tableView containing rowKeys
 */
export default function getInstrumentationContextsFromTableView(rowKeys, tableView) {
    var instrumentationContexts = rowKeys.map(function (rowKey) {
        var instrumentationContext = getInstrumentationContext(rowKey, tableView);
        return instrumentationContext;
    });
    return instrumentationContexts.filter(function (ic) { return ic; });
}
//# sourceMappingURL=getInstrumentationContextsFromTableView.js.map